// Single source of truth for the contact addresses shown across the auth flows.
export default () => {
  const noReplyEmail = 'noreply@emissary.ai'
  const supportEmail = 'support@emissary.ai'
  return {
    noReplyEmail,
    supportEmail
  }
}
